import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { environment } from "src/environments/environment";
import { CommonService } from "src/app/services/common/common.service";

@Component({
  selector: "app-attachments",
  templateUrl: "./attachments.component.html",
  styleUrls: ["./attachments.component.scss"],
})
export class AttachmentsComponent implements OnInit {
  @Input() attachments: any = [];
  @Output() attachmentsChange = new EventEmitter<Array<any>>();
  @Input() uploadedById: number | null = null;
  @Input() uploadedByEmail: string | null = null;
  @Input() editable = true;

  constructor(private commonService: CommonService) {}

  ngOnInit() {}

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      const filesizeMb = file.size / (1024 * 1024);
      this.commonService.uploadFile(
        file,
        (resp) => {
          const filename = resp?.image?.filename;
          if (!filename) return;
          const fileData = {
            name: file.name,
            filesize: filesizeMb,
            filetype: file.type,
            url: `${environment.taskSharingApiUrl}/uploads/${filename}`,
            creationDate: new Date().toISOString(),
            uploadedById: this.uploadedById,
            uploadedByEmail: this.uploadedByEmail,
          };
          this.attachments.push(fileData);
          this.attachmentsChange.emit(this.attachments);
        },
        () => console.error("Attachment upload failed")
      );
    }

    // allow selecting same file again
    event.target.value = "";
  }

  downloadAttachment(attachment: any) {
    const url = this.getAttachmentUrl(attachment);
    if (!url) return;

    const link = document.createElement("a");
    link.href = url;
    link.download = attachment?.name || "attachment";
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    link.click();
  }

  deleteAttachment(attachment: any) {
    this.attachments = this.attachments.filter((item) => item !== attachment);
    this.attachmentsChange.emit(this.attachments); // Emit sự thay đổi
  }

  /**
   * Some existing attachments may store `filesize` as bytes.
   * This normalizes the display to MB.
   */
  getFilesizeMb(filesize: any): number {
    if (filesize === undefined || filesize === null) return 0;
    const n = typeof filesize === 'number' ? filesize : parseFloat(`${filesize}`);
    if (Number.isNaN(n) || n <= 0) return 0;

    const bytesThreshold = 1024 * 1024;
    if (n >= bytesThreshold) {
      return n / (1024 * 1024);
    }

    return n;
  }

  getAttachmentUrl(attachment: any): string {
    return attachment?.url || attachment?.base64 || "";
  }

  getFiletypeLabel(attachment: any): string {
    const filetype = `${attachment?.filetype || ""}`.trim();
    if (filetype) return filetype;

    const name = `${attachment?.name || ""}`.toLowerCase();
    const ext = name.includes(".") ? name.split(".").pop() : "";
    return ext ? `.${ext}` : "file";
  }

  getCreatedAtLabel(attachment: any): string {
    const raw = attachment?.creationDate || attachment?.createdAt || attachment?.created_at;
    if (!raw) return "";
    const d = new Date(raw);
    if (Number.isNaN(d.getTime())) return "";
    return d.toLocaleString();
  }
}
